import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPhotoToIllustrationConfig } from '@/data/landingConfig/landingPhotoToIllustrationConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PhotoToIllustration } from './schemaObject';

interface Props {}

const PhotoToIllustration: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PhotoToIllustration} />
			<LandingTemplate
				data={landingPhotoToIllustrationConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default PhotoToIllustration;
